import { ErrorHandler, Injectable } from '@angular/core';
import * as Sentry from '@sentry/angular';
import { isSessionAuthHttpError } from './app/http/session-auth-failure';
import {
  isAngularRouterNoMatchError,
  isIgnorableClientApiNetworkFailure,
  isIgnorableNgswVersionCheckNetworkFailure,
  isLazyChunkLoadFailure,
  tryRecoverFromLazyChunkFailure,
} from './app/sentry/sentry-event-filter';
import { environment } from './environments/environment';

@Injectable()
export class SentryErrorHandler implements ErrorHandler {
  handleError(error: any): void {
    if (tryRecoverFromLazyChunkFailure(error)) {
      return;
    }

    if (isSessionAuthHttpError(error) || isSessionAuthHttpError(error?.originalError)) {
      throw error;
    }

    if (!isAngularRouterNoMatchError(error)) {
      const root = error?.originalError ?? error;
      const skipNetworkNoise =
        isIgnorableClientApiNetworkFailure(root, environment.apiUrl) ||
        isIgnorableClientApiNetworkFailure(error, environment.apiUrl) ||
        isIgnorableNgswVersionCheckNetworkFailure(root) ||
        isIgnorableNgswVersionCheckNetworkFailure(error);

      if (!skipNetworkNoise) {
        if (isLazyChunkLoadFailure(error) || isLazyChunkLoadFailure(root)) {
          // Recovery esgotado: sinaliza deploy/stale cache sem fingerprint por hash de chunk.
          Sentry.withScope((scope) => {
            scope.setLevel('warning');
            scope.setTag('lazy_chunk_recovery', 'exhausted');
            scope.setFingerprint(['wosi-lazy-chunk-load-failure']);
            Sentry.captureException(root);
          });
        } else {
          Sentry.captureException(root);
        }
      }
    }
    throw error;
  }
}
